import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import { Box, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';

// Sits beside a partner's placeholder email (<uuid>@perfectrx.com): kept on file, never emailed.
const PlaceholderEmailMarker = ({ sx }) => (
  <Tooltip title='Placeholder address — never emailed'>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        flexShrink: 0,
        color: 'text.secondary',
        ...sx,
      }}
    >
      <NotificationsOffOutlinedIcon aria-hidden sx={{ fontSize: 14 }} />
      <Typography variant='caption'>Not emailed</Typography>
    </Box>
  </Tooltip>
);

PlaceholderEmailMarker.propTypes = {
  sx: PropTypes.shape({}),
};

PlaceholderEmailMarker.defaultProps = {
  sx: undefined,
};

export default PlaceholderEmailMarker;
